import { createContext, useContext } from 'react';

export type FillableBlanksContextType = {
  fillableBlanks: Record<string, string>;
};

export const FillableBlanksContext = createContext<FillableBlanksContextType>({ fillableBlanks: {} });

export const useFillableBlanksContext = () => useContext(FillableBlanksContext);
